var map = {
	"./accounts-highlight-admin-icon.svg": 366,
	"./audit-logs-highlight-admin-icon.svg": 367,
	"./campaigns-highlight-admin-icon.svg": 368,
	"./coupons-highlight-admin-icon.svg": 369,
	"./dashboard-highlight-admin-icon.svg": 370,
	"./event-calendar-highlight-admin-icon.svg": 371,
	"./notification-highlight-admin-icon.svg": 372,
	"./orders-highlight-admin-icon.svg": 374,
	"./payment-gateways-highlight-admin-icon.svg": 375,
	"./plans-highlight-admin-icon.svg": 376,
	"./settings-highlight-admin-icon.svg": 377,
	"./subscriptions-highlight-admin-icon.svg": 378,
	"./templates-highlight-admin-icon.svg": 379,
	"./users-highlight-admin-icon.svg": 380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 386;